import { createWebflowBundle } from "../../../shared/create-bundle";
import { QuestionnairePage } from "./questionnaire-page";

createWebflowBundle("questionnaire", QuestionnairePage, "QuestionnairePage");
